module.exports = __webpack_public_path__ + "static/media/benefits-img-6.8b74bdd8.png";